import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=74965e54&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=74965e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74965e54",
  null
  
)

export default component.exports